import styled from 'styled-components'
export const GreenStarSpan = styled.span`
  margin: 0 0 0 5px;
`

export const ShortlistDiv = styled.div `
font-family: Plus Jakarta Sans;
font-size: 20px;
font-weight: 700;
line-height: 28px;
letter-spacing: 0em;
text-align: center;
color: #010E30;
width: 451px;
height: 28px;
margin-top: 15px;
margin-bottom: 15px;
`